import checkIsValidEmail from './check-is-valid-email';
import {checkIsValidFile} from './check-is-valid-file';

export {checkIsValidEmail, checkIsValidFile};
